import React from "react";
import { useLocation } from "react-router-dom";
import { Fade, Slide, Bounce } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
function  OtherProductsCard({ item }) {
    const navigate = useNavigate();
    const goToProducts = (item) => {
        navigate(`/products/${item.linkRoute}`);
        window.scrollTo(0, 0);
    };

    const location=useLocation()
console.log("location", location)
    return (
        <div
            key={item.id}
            onClick={() => goToProducts(item)}
            className={`relative  z-40 bg-black w-full flex flex-col py-4  duration-200 ease-linear ${
                location.pathname === `/products/${item.linkRoute}`
                    ? "grayscale opacity-40  cursor-default"
                    : " hover:opacity-100 opacity-70 cursor-pointer"
            }`}
        >
            <img
                src={item.otherProductImage}
                alt=""
                className={`w-full absolute top-0 left-0 z-[-10] object-cover  object-center min-h-[240px]  h-full `}
            />

            <div
                className={`text-white flex-col flex p-4 md:p-10  w-full  justify-between h-[240px] md:min-h-[436px] ${
                    location.pathname === `/products/${item.linkRoute}`
                        ? "line-through"
                        : ""
                }`}
            >
                <div className={`flex flex-col  w-full `}>
                    {" "}
                    <h7 className="font-bold  text-[14px] leading-[48px] h25">
                        0{item?.id}
                    </h7>
                    <h7 className=" sm:text-[14px] sm:leading-[48px]  text-[12px] leading-[21px] h26">
                        {item?.protocol}
                    </h7>
                </div>
                <div className=" w-full flex flex-col justify-end items-start h-[160px]">
                    <h3 className="text-[24px] sm:text-[30px] leading-[24px] sm:leading-[30px]">
                        {item?.name}
                    </h3>
                    <p className="text-[12px] sm:text-[14px] leading-[21px] sm:leading-[48px] md:min-h-[41px] mt-2 md:mt-5">
                        {item?.layer}
                    </p>
                </div>
                {/* Changed h7 to p as h7 is not a valid HTML tag */}
            </div>
        </div>
    );
}

export default OtherProductsCard;
